import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import {appName} from "../Components/constants/default";


const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <div className="col-lg-12">
                          <div className="text-center">
                            <p className="text-muted fs-10 mb-1">&copy; {new Date().getFullYear()} {appName}. Designed & developed by T-code Tomasz Hliwiadczyn</p>
                          </div>
                        </div>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;
